import script from "./EditorPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorPopup.vue?vue&type=script&setup=true&lang=js"

import "./EditorPopup.vue?vue&type=style&index=0&id=5c33e320&scoped=true&lang=css"

import exportComponent from "/home/sergio/Escritorio/VSCode/Rosepetal/0.5.x-sergio/rosepetal-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c33e320"]])

export default __exports__